import angular from 'angular';

// Directives list

// houseUnit                        update_basic.php
// estPopupUrl                 -A   модальное окно (маленький попап)
// estLargePopupUrl            -A   большой попап, сейчас используется только на странице Objects + хендлит попап Юнита и Лида Славы
// closeLargePopup             -A   только в попапе на странице Objects
// bindHtmlCompile             -A   вставляет разные темплейты в модальное окно estPopupUrl
// estBuildingCompletion            на странице Basic добавления объекта
// popupSubmit                 -A   many responsibilities
// estActivateHouse                 изменение юнитов: sold, booked, not in stock, plot, office, no unit, split, merge
// estNextBlock                   не используется
// estBasicAddParking               _basic.php кнопка добавления паркинга, темплейт паркинга подключается в _edit_parking.php
// estRemoveParking                 _edit_parking.php
// estRooms                         update_rooms.php, очистка после ввода, подсчет количества квартир для статистики
// estRoomsOffice                   update_rooms.php, считает офисы
// estAreas                         update_area.php, в том числе код, который заменяет при вводе , на .
// estHouseColumn                   ввод над столбцами на страницах update... area rooms price
// estPrices                        инпут цены для обычного и разделенного юнита
// estHouseFloor                  не используется
// estAptAutoset                    кнопка AutoSet при сквозной нумерации - _numeration.php
// estAptSingle                     инпут update_numeration.php
// estAptField                      очищает инпут, противоположный текущему выбору (либо нумерация с первой, либо с последней)
// estTowerAutoset                  кнопка AutoSet при нумерации по айдишникам - _numeration.php
// estTowerId                       update_numeration.php захардкожено значение 1, похоже нигде не используется, вместо него estSectionId
// estFloorValue                    инпут напротив строки сетки юнитов
// estFeatureUnit                   update_features.php окрашивание юнитов при клике
// estMarkFeature                   кнопка Mark у фич и у кастом-фич
// featureLabel                     квадратики фич в каждом юните
// estFeatureHighlight              подсветка юнитов по наведению на кол-во юнитов с определенной фичей
// featureCustom                  не используется
// customLabel                      добавляемое в строку js-customFeatureString значение
// estCustomHighlight               подсветка юнитов по наведению на кол-во юнитов с определенной кастом-фичей
// estReviewUnit                    поведение по клику на юнит (окрашивание и открытие попапа)
// estImageColumn                   подсветка и применение изображений к колонкам сетки юнитов
// deleteImage                      что нужно сделать при удалении изображения (убираются отметки, удаляется изображение)
// deleteAvatar                     что нужно сделать при удалении аватара (ajax post и т.д.)
// estPlanUnit                      подсветка отдельный юнитов при добавлении изображений, а также click действие
// estMarkImage                     кнопка Mark у изображений
// attachImage                      скрытые инпуты, который хранят информацию о примененных изображениях
// imageFloor      sections only    controler + template _image.php Вывод информации: к каким этажам применены планы этажей
// imageHighlight                  не используется похоже (пустая link-функция), подсветка по наведению на значение Linked to, в темплейте то обращается к ангуляровскому айди, то к php

// estSelectTag             УДАЛИЛ   выбор статусов, по которым искать на странице юнитов
// estRemoveTag             УДАЛИЛ   удаление выбранных статусов, по которым идет поиск на странице юнитов
// roomsFilter              УДАЛИЛ   фильтр по количеству комнат
// quantityFilter           УДАЛИЛ   фильтр по площади, цене, этажу
// filterField              УДАЛИЛ   поведение доп. инпутов (применение на Enter и отмена на Escape)
// estFilter                УДАЛИЛ   запрет действий в строке запроса, отслеживание изменений в строке и отправка запроса фильтрации юнитов

angular
  .module('estoffice.legacy')
  .directive(
    'houseUnit',
    function (
      unit,
      $compile,
      /** @type {angular.material.IDialogService} */ $mdDialog,
      $translate,
      $rootScope,
    ) {
      return {
        scope: {
          unitId: '@unitId',
        },
        link: function (scope, element, attr) {
          var textApt = $translate.instant('projects.unit.type.apt');
          var textComm = $translate.instant('projects.unit.type.commercial');
          var textVilla = $translate.instant('projects.unit.type.villa');
          var textPlot = $translate.instant('projects.unit.type.plot');
          $rootScope.$on('$translateChangeSuccess', function () {
            textApt = $translate.instant('projects.unit.type.apt');
            textComm = $translate.instant('projects.unit.type.commercial');
            textVilla = $translate.instant('projects.unit.type.villa');
            textPlot = $translate.instant('projects.unit.type.plot');
          });

          var mergeFlag = true;
          element
            //TODO подсветка последней квартиры
            .on('mouseenter', function (event) {
              //подсветка правой квартиры
              if (unit.activeHouse) {
                if (unit.activeHouse === 'merge') {
                  var rightSibling = element.parent().nextAll();
                  //если квартира не обьединненая
                  if (element.parent().is(':last-child')) {
                    return false;
                  }

                  if (
                    !element.hasClass('-type_united') ||
                    element.hasClass('-type_divided')
                  ) {
                    rightSibling.each(function (i, el) {
                      //если правая квартира объединенная не подсвечиваем
                      if (
                        $(el).hasClass('-type_united') ||
                        $(el).hasClass('-type_divided')
                      ) {
                        mergeFlag = false;
                        return false;
                      }
                      if (!$(el).hasClass('g-hidden')) {
                        $(el).find('.b-house__unit').addClass('-type_featured');
                        mergeFlag = false;
                        return false;
                      }
                    });
                  }
                } else {
                  element.addClass('-type_featured');
                }
              }
            })
            .on('mouseleave', function (event) {
              var mergeFlag = true;
              $('.b-house__unit').removeClass('-type_featured');
            })
            .on('click', function (event) {
              switch (unit.activeHouse) {
                case 'merge':
                  var rightSibling = element.parent().next();
                  if (rightSibling.length) {
                    //если элемент уже обьединенный
                    if (element.hasClass('-type_united')) {
                      element
                        .removeClass('-type_united')
                        .parent()
                        .removeClass('-type_united')
                        .next()
                        .removeClass('g-hidden')
                        .find('.b-house__unit')
                        .removeClass('g-hidden');
                      updateGrid();
                      unit
                        .merge(
                          attr.unitId,
                          rightSibling
                            .find('.b-house__unit')
                            .attr('data-unit-id'),
                        )
                        .then(function (data) {});
                    } else {
                      if (
                        !rightSibling.hasClass('-type_united') &&
                        !rightSibling.hasClass('-type_divided')
                      ) {
                        element
                          .addClass('-type_united')
                          .parent()
                          .addClass('-type_united')
                          .next()
                          .addClass('g-hidden')
                          .find('.b-house__unit')
                          .addClass('g-hidden');
                        updateGrid();
                        unit
                          .merge(
                            attr.unitId,
                            rightSibling
                              .find('.b-house__unit')
                              .attr('data-unit-id'),
                          )
                          .then(function (data) {});
                      }
                    }
                  }
                  break;
                case 'split':
                  if (!element.hasClass('-type_united')) {
                    if (element.hasClass('-type_divided')) {
                      if (element.is(':last-child')) {
                        element
                          .prev()
                          .removeClass('-type_divided')
                          .parent()
                          .removeClass('-type_divided');
                        element.remove();
                      } else {
                        element.next().remove();
                        element
                          .removeClass('-type_divided')
                          .parent()
                          .removeClass('-type_divided');
                      }
                    } else {
                      element
                        .addClass('-type_divided')
                        .parent()
                        .addClass('-type_divided');
                      var clone = element.clone();
                      var cloneCompile = $compile(clone)(scope);
                      element.after(cloneCompile);
                    }
                    updateGrid();
                    unit.split(attr.unitId).then(function (data) {
                      if (data.action == 'split') {
                        clone
                          .attr('data-unit-id', data.split_unit.unit_id)
                          .find('.b-houseroom__title')
                          .text(data.split_unit.custom.typeLabel);
                      }
                    });
                  }
                  break;
                case 'nounit':
                  element.toggleClass('-type_nounit');

                  unit.markedOffice(attr.unitId, 1).then(function (data) {});
                  break;
                case 'office':
                  var type = element.attr('data-unit-type') === 'Apt.' ? 3 : 2;
                  var typeText =
                    element.attr('data-unit-type') === 'Apt.'
                      ? textComm
                      : textApt;
                  unit.markedOffice(attr.unitId, type).then(function (data) {
                    element.find('.b-houseroom__title').text(typeText);
                    element.attr('data-unit-type', data.type);
                    if (data.result.type == 2) {
                      element
                        .find('.b-houseroom__indicate')
                        .text(data.result.rooms);
                    } else if (data.result.type == 3) {
                      element.find('.b-houseroom__indicate').text('-');
                    }
                  });
                  break;
                case 'plot':
                  var type = element.attr('data-unit-type') === 'Villa' ? 5 : 4;
                  var typeText =
                    element.attr('data-unit-type') === 'Villa'
                      ? textPlot
                      : textVilla;
                  unit.markedOffice(attr.unitId, type).then(function (data) {
                    element.find('.b-houseroom__title').text(typeText);
                    element.attr('data-unit-type', data.type);
                  });
                  break;

                default:
                  return false;
              }
            });
          var showDialog = function (content) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element('body'))
                .clickOutsideToClose(true)
                .textContent(content)
                .ariaLabel('Alert Dialog Demo')
                .ok('ok'),
            );
          };
        },
      };
    },
  )
  .directive(
    'estPopupUrl',
    function (
      request,
      /** @type {angular.material.IDialogService} */ $mdDialog,
      unit,
    ) {
      return {
        restrict: 'A',
        scope: {
          url: '@estPopupUrl',
          title: '@estPopupTitle',
          afterSubmitText: '@',
        },
        link: function (scope, element, attr) {
          element.on('click', function (event) {
            unit.editElement = element;
            //var parent = unit.editElement.parents('.js-houseBlock');
            //scope.name = parent.find('.js-objectName').text();
            //scope.location = parent.find('.js-objectLocation').text();
            event.preventDefault();

            $mdDialog.show(
              // @ts-expect-error - alert actually supports arguments
              // but this feature is not covered with types
              $mdDialog.alert({
                targetEvent: event,
                parent: angular.element('body'),
                template: require('./popup.html'),
                preserveScope: true,
                controller: 'PopupCtrl',
                scope: scope,
              }),
            );
          });
        },
      };
    },
  )
  .directive(
    'estLargePopupUrl',
    function (
      request,
      $templateCache,
      $compile,
      $rootScope,
      api,
      unit,
      $state,
      $location,
    ) {
      return {
        restrict: 'A',
        scope: {
          url: '@estLargePopupUrl',
          typePopup: '@',
        },
        link: function (scope, element, attr) {
          element.on('click', function (event) {
            event.preventDefault();
            if (attr.typePopup == 'unit') {
              $state.go('unitpopup.view', { id: attr.unitId });
              return;
            } else if (attr.typePopup == 'lead') {
              $state.go('leadpopup.view', { id: attr.unitId });
              return;
            } else if (attr.estLargePopupType == 'house') {
              $rootScope.houseId = attr.unitId;
            }

            // Need this so popup on Objects page works

            var html = $(element).html();
            html = html.replace(/\s/g, '');

            if (html != '') {
              window.location.hash = attr.unitId;
              $('.b-house__unit.-state-active')
                .removeClass('-state-active')
                .addClass('-state-inactive');
              element.addClass('-state-active');
              $(
                '.js-largePopup[data-type-popup=' + scope.typePopup + ']',
              ).remove();
              var sidebarPopup = require('./largePopup.html');
              var compileSidebar = $compile(sidebarPopup)(scope);
              compileSidebar.attr('data-type-popup', scope.typePopup);

              $('.l-sidebar').append(compileSidebar);

              $('.js-spinnerPopup').show();
              $('.mdl-js-layout').addClass('-sidebar_expanded');
              $('.js-scrollbars').perfectScrollbar().perfectScrollbar('update');
              /*if(!$('.l-sidebar').hasClass('-page_leads')) {
              var offsetLeft = $(window).width() - $('.l-sidebar').offset().left;
              $('.b-sidebar__close, .b-sidebarPopup').css('left', 'calc(100vw - ' + offsetLeft + 'px)');
            }*/

              var url = scope.url.replace('unitId', attr.unitId);

              request.post(url, {}, function (response) {
                unit.productionId = attr.unitId;
                var compile = $compile(response.data)(scope);
                $('.b-sidebarPopup', compileSidebar).html(compile);
                $('.js-scrollbars').perfectScrollbar('update');
                unit.initJqueryFunc();
                $('.js-spinnerPopup').hide();
              });
            }
          });
        },
      };
    },
  )
  .directive('closeLargePopup', function ($location, unit, $state) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        element.on('click', function (event) {
          event.preventDefault();

          if (
            $state &&
            $state.current &&
            ($state.current == 'unitpopup.view' ||
              $state.current == 'leadpopup.view')
          ) {
            $state.go('main');

            return;
          }

          var hash = '';

          element.parents('.js-largePopup').remove();
          if (!$('.l-sidebar .js-largePopup').length) {
            $('.mdl-js-layout').removeClass('-sidebar_expanded');
            $('.b-house__unit').removeClass('-state-active');
          } else {
            var $el = $('.b-house__unit.-state-inactive');
            $el.removeClass('-state_inactive').addClass('-state-active');
            hash = $el.data('unit-id');
          }
          window.location.hash = hash;
          //unit.initJqueryFunc();
        });
      },
    };
  })
  .directive('bindHtmlCompile', function ($compile) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(
          function () {
            return scope.$eval(attrs.bindHtmlCompile);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          },
        );
      },
    };
  })
  .directive('estBuildingCompletion', function (api, request, debounce) {
    return {
      scope: false,
      link: function (scope, element, attr) {
        scope.$watch(attr.ngModel, function () {
          scope.requestLoader = true;

          var data = {
            ready_qr: $('input[name="ready_qr"]').val(),
            ready_year: $('input[name="ready_year"]').val(),
          };

          var url = api.basic.buildingPhase.replace(
            '{{sectionId}}',
            attr.sectionId,
          );

          debounce(function () {
            request.post(url, data, function (response) {
              scope.requestLoader = false;
            });
          }, 1000);
        });
      },
    };
  })
  .directive(
    'popupSubmit',
    function (
      $compile,
      $templateCache,
      /** @type {angular.material.IDialogService} */ $mdDialog,
      $window,
      $rootScope,
      $cookieStore,
      $timeout,
      unit,
      $translate,
    ) {
      return {
        restrict: 'A',
        scope: {
          formId: '@popupSubmit',
          type: '@',
          show: '=',
          status: '=',
          cardLead: '=',
          cardObject: '=',
          statusDay: '=',
          submitCallback: '&',
          loader: '=',
          clearForm: '=',
          submitHide: '=',
          close: '@',
        },
        link: function (scope, element, attr) {
          var textDraftTitle = $translate.instant(
            'projects.review.save.modal.draft.title',
          );
          var textDraftContent = $translate.instant(
            'projects.review.save.modal.draft.content',
          );
          var textPublishedTitle = $translate.instant(
            'projects.review.save.modal.published.title',
          );
          var textPublishedContent = $translate.instant(
            'projects.review.save.modal.published.content',
          );
          var textGotIt = $translate.instant('general.modal.got.it');
          var textAreYouSure = $translate.instant('general.modal.are.you.sure');
          $rootScope.$on('$translateChangeSuccess', function () {
            textDraftTitle = $translate.instant(
              'projects.review.save.modal.draft.title',
            );
            textDraftContent = $translate.instant(
              'projects.review.save.modal.draft.content',
            );
            textPublishedTitle = $translate.instant(
              'projects.review.save.modal.published.title',
            );
            textPublishedContent = $translate.instant(
              'projects.review.save.modal.published.content',
            );
            textGotIt = $translate.instant('general.modal.got.it');
            textAreYouSure = $translate.instant('general.modal.are.you.sure');
          });

          element.on('click', function (event) {
            event.preventDefault();
            var url = $('#' + scope.formId).attr('action');

            if (typeof scope.loader != 'undefined') {
              scope.loader = true;
            }

            if (scope.formId == 'delete_object') {
              if (window.confirm(textAreYouSure)) {
                $.ajax({
                  url: url,
                  type: 'post',
                  dataType: 'json',
                  data: $('#' + scope.formId).serialize(),
                  error: function () {
                    console.log('error ajax');
                  },
                  success: function (data) {
                    scope.submitCallback({ response: data });

                    // заменил вермишель Джона на простую перезагрузку страницы
                    $window.location.reload(true);
                  },
                });
              }
            }

            $.ajax({
              url: url,
              type: 'post',
              dataType: 'json',
              data: $('#' + scope.formId).serialize(),
              error: function () {
                console.log('error ajax');
              },
              success: function (data) {
                scope.submitCallback({ response: data });

                if (scope.formId == 'create_object') {
                  // заменил вермишель Джона на простую перезагрузку страницы
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                } else if (scope.formId == 'update_object') {
                  // заменил вермишель Джона на простую перезагрузку страницы
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                } else if (scope.formId == 'delete_object') {
                  unit.editElement.parents('.b-projects__item').remove();
                } else if (
                  scope.formId == 'create_house' ||
                  scope.formId == 'create_blocks'
                ) {
                  // создан новый объект(ы), после закрытия модалки произойдет перезагрузка страницы
                  $rootScope.newObjectAdded = true;
                } else if (scope.formId == 'update_house') {
                  var item = unit.editElement.closest('.b-projects__item');
                  $('.js-houseName', item).text(data.result.name);
                  $('.js-houseCity', item).text(data.result.city);
                  $('.js-houseLocation', item).text(data.result.location);
                } else if (scope.formId == 'delete_house') {
                  unit.editElement.closest('.b-projects__item').remove();
                } else if (
                  scope.formId == 'create_section' ||
                  scope.formId == 'create_block'
                ) {
                  // создана новая секция, после закрытия модалки произойдет перезагрузка страницы
                  $rootScope.newSectionAdded = true;
                  $cookieStore.put('object', $rootScope.houseId);
                } else if (scope.formId == 'update_user') {
                  // перезагружаем окно
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                }

                // TODO change update_section to update_section_status
                else if (
                  scope.formId == 'update_section' &&
                  $('.mdl-layout__content').hasClass('js-review-page')
                ) {
                  if (data.result.status == 1) {
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .clickOutsideToClose(true)
                        .title(textDraftTitle)
                        .textContent(textDraftContent)
                        .ariaLabel('Alert Dialog')
                        .ok(textGotIt),
                    );
                  } else if (data.result.status == 2) {
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .clickOutsideToClose(true)
                        .title(textPublishedTitle)
                        .textContent(textPublishedContent)
                        .ariaLabel('Alert Dialog')
                        .ok(textGotIt),
                    );
                  }
                } else if (
                  (scope.formId == 'update_section' ||
                    scope.formId == 'delete_section' ||
                    scope.formId == 'update_block' ||
                    scope.formId == 'delete_block') &&
                  !$('.mdl-layout__content').hasClass('js-review-page')
                ) {
                  // Запоминаем, с каким объектом работали
                  $cookieStore.put('object', $rootScope.houseId);
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                }
              },
            });

            if (typeof scope.close != 'undefined' && scope.close) {
            } else {
              $mdDialog.hide();
            }

            if (typeof scope.show != 'undefined') {
              scope.$apply(function () {
                scope.show = false;
              });
            }

            if (typeof scope.clearForm != 'undefined' && scope.clearForm) {
              scope.$apply(function () {
                $('#' + scope.formId).trigger('reset');
                unit.initJqueryFunc();
                $('select').trigger('refresh');
              });
            }
          });
        },
      };
    },
  )
  .directive('estActivateHouse', function (unit) {
    return {
      scope: {
        type: '@estActivateHouse',
      },
      link: function (scope, element, attr) {
        scope.activeHouse = false;
        element.on('click', function (event) {
          event.preventDefault();
          $('.js-activateHouse').not(element).removeClass('-state_done');
          $(element).toggleClass('-state_done');
          scope.activeHouse = $(element).hasClass('-state_done');
          if (scope.activeHouse) {
            unit.activeHouse = scope.type;
            $('.b-house').addClass('-type_edit');
          } else {
            unit.activeHouse = '';
            $('.b-house').removeClass('-type_edit');
          }
        });
      },
    };
  })
  .directive('estNextBlock', function (api, request) {
    return {
      scope: false,
      link: function (scope, element, attr) {
        element.on('click', function (event) {
          event.preventDefault();
          var data = {
            ready_qr: scope.basicReadyQuarter,
            ready_year: scope.basicReadyYear,
          };
          var url = api.unit.buildingPhase.replace(
            '{{sectionId}}',
            scope.sectionId,
          );
          request.post(url, data, function (response) {
            window.location = attr.href;
          });
        });
      },
    };
  })
  .directive(
    'estBasicAddParking',
    function (api, request, unit, $templateCache, $compile, $rootScope) {
      return {
        scope: {},
        link: function (scope, element, attr) {
          unit.countParking = 1;
          element.on('click', function (event) {
            event.preventDefault();
            if (unit.countParking < 5) {
              var parking = require('./parking.html');
              var data = {
                parking: unit.countParking,
              };

              var url = api.basic.buildingPhase.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );
              request.post(url, data, function () {
                var compileParking = $compile(parking)(scope);
                var $parking = $('.b-house__parking');
                $parking.append(compileParking);
                var parkingWidth = $parking
                  .prev()
                  .find('.b-house__floorHouserooms')
                  .width();
                $parking.find('.b-house__floorHouserooms').width(parkingWidth);
                unit.countParking += 1;
              });
            }
          });
        },
      };
    },
  )
  .directive('estRemoveParking', function (api, request, unit, $rootScope) {
    return {
      scope: {},
      link: function (scope, element, attr) {
        element.on('click', function (event) {
          event.preventDefault();
          var data = {
            parking: unit.countParking - 1,
          };
          var url = api.basic.buildingPhase.replace(
            '{{sectionId}}',
            $rootScope.sectionId,
          );
          request.post(url, data, function () {
            element.parents('.b-house__floor').remove();
          });
        });
      },
    };
  })
  .directive('estRooms', function (api, request, unit, $rootScope, debounce) {
    return {
      scope: {
        value: '=ngModel',
        type: '@estRooms',
        id: '@unitId',
      },
      link: function (scope, element, attr) {
        // очищение инпута после фокусирования на любой другой инпут

        element.on('focus', function () {
          $('.b-textfield[data-est-house-column]').val('');
        });
        if (!element.parents('.b-house__unit').hasClass('g-hidden')) {
          unit.count.rooms[attr.unitId] = attr.value;
        }

        // наверное, не нужно считать офисы здесь, этот код есть в директиве  estRoomsOffice

        if (scope.type === 'Office') {
          unit.count.offices += 1;
        }
        scope.$watch('value', function (newVal, oldVal) {
          unit.oldValRooms = oldVal;
          if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
            var data = { rooms: {} };
            var url = api.rooms.change.replace(
              '{{sectionId}}',
              $rootScope.sectionId,
            );
            if (!element.parents('.b-house__unit').hasClass('g-hidden')) {
              data.rooms[attr.unitId] = scope.value;
              data.price_id = unit.priceId;
              unit.count.rooms[attr.unitId] = scope.value;
            }
            if (!unit.columnChange) {
              debounce(function () {
                $rootScope.updateStatistic();
                request.post(url, data, function (response) {});
              }, 300);
            }
          }
        });
        element.on('blur', function (event) {
          if (!element.val()) {
            scope.value = unit.oldValRooms;
          }
        });
      },
    };
  })
  .directive('estRoomsOffice', function (unit) {
    return {
      scope: {
        type: '@estRoomsOffice',
      },
      link: function (scope, element, attr) {
        if (scope.type == 'Office') {
          unit.count.offices += 1;
        }
      },
    };
  })
  .directive('estAreas', function (api, request, unit, $rootScope, debounce) {
    //у офис только input area _total
    return {
      scope: {
        value: '=ngModel',
        type: '@estAreas',
        id: '@unitId',
        ngDisabled: '=',
        floorType: '=estFloorType',
        ngModel: '=',
      },
      link: function (scope, element, attr) {
        element.on('focus', function () {
          $('.b-textfield[data-est-house-column]').val('');
        });
        if (scope.type === 'Office' || scope.type === 'Plot') {
          scope.ngDisabled = true;
        } else {
          scope.ngDisabled = false;
        }
        scope.$watch('floorType', function (newVal, oldVal) {
          if (newVal != oldVal) {
            if (scope.type === 'Office') {
              scope.ngDisabled = !newVal;
            } else if (scope.type === 'Plot') {
              scope.ngDisabled = !newVal;
            } else {
              scope.ngDisabled = newVal;
            }
          }
        });
        scope.$watch('value', function (newVal, oldVal) {
          if (newVal) {
            var newTest = newVal.toString();
            var ft = newTest.replace(',', '.');
          }

          unit.oldValRooms = oldVal;
          if (newVal != oldVal && newVal != '') {
            var data = {};
            data[attr.name] = ft;
            scope.ngModel = ft;
            var url = api.area.change.replace(
              '{{sectionId}}',
              $rootScope.sectionId,
            );
            if (!unit.columnChange) {
              debounce(function () {
                request.post(url, data);
              }, 500);
            }
          }
        });

        element.on('blur', function (event) {
          if (!element.val()) {
            scope.value = unit.oldValRooms;
          }
        });
      },
    };
  })
  .directive(
    'estHouseColumn',
    function (api, request, unit, $rootScope, debounce) {
      return {
        scope: {
          value: '=ngModel',
          type: '=estHouseColumn',
          url: '=',
          selector: '=',
        },
        link: function (scope, element, attr) {
          var parent = $(element).closest('.l-houseUnit');
          var index = parent.index();
          element.on('focus', function () {
            $('.b-textfield[data-est-house-column]').val('');
          });
          element.on('blur', function () {
            $('.b-textfield[data-est-house-column]').val('');
          });
          scope.$watch(
            'value',
            function (newVal, oldVal) {
              if (newVal) {
                var newVal = newVal.replace(',', '.');
              }
              if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
                var data = {};
                data[scope.type] = {};
                var url = scope.url.replace(
                  '{{sectionId}}',
                  $rootScope.sectionId,
                );
                if (scope.type == 'price') {
                  data.price_id = unit.priceId;
                }
                angular.forEach(MatrixTower[index].elements, function (el, i) {
                  var selector = scope.selector || '';
                  var input = $(el[0])
                    .find('.b-textfield' + selector + ':first')
                    .not("[disabled='disabled']");
                  if (input.length && !input.hasClass('js-column')) {
                    input.val(newVal);
                    input.trigger('input');
                    unit.columnChange = true;
                    data[scope.type][input.data('unit-id')] = newVal;
                  }
                });
                if (typeof $rootScope.updateStatistic == 'function') {
                  $rootScope.updateStatistic();
                }
                debounce(function () {
                  $rootScope.requestLoader = true;
                  request.post(url, data, function (response) {
                    $rootScope.requestLoader = false;
                    unit.columnChange = false;
                  });
                }, 500);
              }
            },
            true,
          );
        },
      };
    },
  )
  .directive('estPrices', function (api, request, unit, $rootScope, debounce) {
    return {
      scope: {
        value: '=ngModel',
        type: '@estRooms',
        id: '@unitId',
        priceId: '=estPrices',
      },
      link: function (scope, element, attr) {
        scope.$watch('value', function (newVal, oldVal) {
          unit.oldValRooms = oldVal;
          var floor = $(element)
            .parents('.b-house__floor')
            .find('.b-textfield')
            .not('.js-floorExclude');

          // у нас можно вставить в первую колонку значение из нескольких значений, разделенных пробелами
          // в этом случае заполняется строка инпутов
          if (newVal != oldVal && newVal.indexOf(' ') >= 0) {
            var strArray = newVal.split(' ');
            var data = { price: {} };
            var url =
              api.price.change.replace('{{sectionId}}', $rootScope.sectionId) +
              '?pl=' +
              unit.priceId;
            angular.forEach(strArray, function (val, i) {
              floor[i].value = val;
              data.price[$(floor[i]).data('unitId')] = val;
            });
            request.post(url, data);
          }

          if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
            var data = { price: {} };
            var url =
              api.price.change.replace('{{sectionId}}', $rootScope.sectionId) +
              '?pl=' +
              unit.priceId;
            data.price[attr.unitId] = scope.value;

            if (!unit.columnChange) {
              debounce(function () {
                request.post(url, data);
              }, 400);
            }
          }
        });
        element.on('blur', function (event) {
          if (!element.val()) {
            scope.value = unit.oldValRooms;
          }
        });
      },
    };
  })
  .directive(
    'estHouseFloor',
    function (api, request, unit, $rootScope, debounce) {
      return {
        scope: {
          value: '=ngModel',
        },
        link: function (scope, element, attr) {
          scope.$watch('value', function (newVal, oldVal) {
            unit.oldValRooms = oldVal;
            if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
            }
          });
          element.on('blur', function (event) {
            if (!element.val()) {
              scope.value = unit.oldValRooms;
            }
          });
        },
      };
    },
  )
  .directive(
    'estAptAutoset',
    function (api, request, unit, $rootScope, debounce) {
      return {
        scope: {
          value: '=estAptAutoset',
          skipOffice: '=',
          splittedFirst: '=',
        },
        link: function (scope, element, attr) {
          function skipUnit(d, unit, num, last, check) {
            var input = $(unit).find('.b-textfield.num');
            var id = input.data('unit-id');
            console.log(d);
            console.log(num);
            if (check) {
              input.val(num);
              input.trigger('input');
              d.num[id] = num;
              if (last) {
                if (num <= 1) {
                  num = '';
                } else {
                  num--;
                }
              } else {
                num++;
              }
            } else {
              d.num[id] = '';
            }
            return {
              data: d,
              start: num,
            };
          }

          element.on('click', function (event) {
            event.preventDefault();
            var floor,
              data,
              temp,
              startNum = 0;
            if (scope.value.first) {
              startNum = parseInt(scope.value.first);
              floor = $(
                $('.b-house__floor')
                  .not('.-type_parking, .-type_apartmentBlock')
                  .get()
                  .reverse(),
              );
            } else {
              startNum = parseInt(scope.value.last);
              floor = $('.b-house__floor').not(
                '.-type_parking, .-type_apartmentBlock',
              );
            }
            if (!isNaN(startNum)) {
              $('.b-house').find('.b-textfield.num').val('');
              var data = { num: {} };
              floor.each(function (i, row) {
                var units;
                units = $(row).find('.b-house__unit:not(.g-hidden)');
                units = scope.value.last ? units.get().reverse() : units;
                $(units).each(function (j, unit) {
                  var gCheck = false;
                  if ($(unit).find('.b-textfield.num').length) {
                    if (
                      (scope.skipOffice &&
                        $(unit).attr('data-unit-type') != 3) ||
                      !scope.skipOffice
                    ) {
                      gCheck = true;
                      if (
                        $(unit).hasClass('-type_divided') &&
                        scope.splittedFirst &&
                        $(unit).is(':last-child')
                      ) {
                        gCheck = false;
                      }
                    }
                    temp = skipUnit(
                      data,
                      unit,
                      startNum,
                      scope.value.last,
                      gCheck,
                    );
                    data = temp.data;
                    startNum = temp.start;
                  }
                });
              });
              var url = api.apt.change.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );
              request.post(url, data);
            }
          });
        },
      };
    },
  )
  .directive('estAptSingle', function ($rootScope, debounce, api, request) {
    return {
      scope: {
        value: '=ngModel',
      },
      link: function (scope, element, attr) {
        scope.$watch('value', function (newVal, oldVal) {
          if (newVal != oldVal && newVal != '') {
            debounce(function () {
              var url = api.apt.change.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );
              $rootScope.requestLoader = true;
              var data = { num: {} };
              if (scope.$parent.showTowerInput) {
                data.num[attr.unitId] =
                  scope.$parent.num_basic[attr.unitId] + scope.value;
                data.num_clean = {};
                data.num_clean[attr.unitId] = scope.value;
              } else {
                data.num[attr.unitId] = scope.value;
              }
              request.post(url, data, function (response) {
                $rootScope.requestLoader = false;
              });
            }, 700);
          }
        });
      },
    };
  })
  .directive('estAptField', function () {
    return {
      scope: {
        ngModel: '=',
        type: '@estAptField',
      },
      link: function (scope, element, attr) {
        element.on('focus', function (event) {
          if (scope.type == 'first') {
            $('.js-typeNumLast').val('').trigger('input');
          } else if (scope.type == 'last') {
            $('.js-typeNumFirst').val('').trigger('input');
          }
        });
      },
    };
  })
  .directive(
    'estTowerAutoset',
    function (api, request, unit, $rootScope, debounce) {
      return {
        scope: {
          option: '=estTowerAutoset',
          show: '=showInput',
          showTowerInput: '=',
        },
        link: function (scope, element, attr) {
          element.on('click', function (event) {
            event.preventDefault();
            var fieldValue = [];
            scope.showTowerInput = true;
            var fieldLength = $('.js-column').length;
            $('.js-column').each(function (i, input) {
              if ($(input).val() != '') fieldValue.push($(input).val());
            });
            var unitInput = $('.b-house__floor')
              .not('.-type_parking, .-type_apartmentBlock, .-type_basement')
              .get()
              .reverse();

            var alphaTower = scope.option.towerAlphabet;
            var idTower = $(
              '.b-locations .b-locations__link.-state_active > .b-locations__num',
            ).text();
            var data = { num: {}, num_clean: {}, num_basic: {} };

            if (fieldValue.length == 0) {
              $(unitInput).each(function (numFloor, row) {
                numFloor += 1;
                var numUnit = 0;
                $(row)
                  .find('.b-house__unit:not(.g-hidden)')
                  .each(function (j, unitBlock) {
                    var inputNumBasic = angular
                      .element(unitBlock)
                      .find('.b-textfield.num-basic');
                    var inputNumClean = angular
                      .element(unitBlock)
                      .find('.b-textfield.num-clean');
                    if (inputNumClean.data('split') == 1) {
                      numUnit += 'A';
                    } else {
                      numUnit = parseInt(numUnit);
                      numUnit += 1;
                    }

                    if ($(unitBlock).find('.b-textfield').length) {
                      if (scope.option.floorNum) {
                        var floorStr =
                          scope.option.floorSeparator +
                          unit.pad(numFloor, scope.option.floorNum);
                      } else {
                        var floorStr = '';
                      }

                      if (scope.option.aptNum) {
                        var aptStr = unit.pad(numUnit, scope.option.aptNum);
                      } else {
                        var aptStr = '';
                      }
                      var num_basic =
                        alphaTower +
                        scope.option.towerSeparator +
                        idTower +
                        floorStr +
                        scope.option.aptSeparator;
                      var num = num_basic + aptStr;
                      var num_clean = unit.pad(numUnit, scope.option.aptNum);

                      inputNumBasic.val(num_basic).trigger('input');
                      inputNumClean
                        .val(unit.pad(numUnit, scope.option.aptNum))
                        .trigger('input');
                      data.num[inputNumBasic.data('unit-id')] = num;
                      data.num_basic[inputNumBasic.data('unit-id')] = num_basic;
                      data.num_clean[inputNumClean.data('unit-id')] = num_clean;
                    }
                  });
              });
              scope.show = false;
            } else if (fieldValue.length == fieldLength) {
              scope.show = false;
              $(unitInput).each(function (numFloor, row) {
                numFloor += 1;
                $(row)
                  .find('.l-houseUnit:not(.g-hidden)')
                  .each(function (j, unitBlock) {
                    if ($(unitBlock).find('.b-textfield').length) {
                      var inputNumBasic = angular
                        .element(unitBlock)
                        .find('.b-textfield.num-basic');
                      var inputNumClean = angular
                        .element(unitBlock)
                        .find('.b-textfield.num-clean');
                      var indexUnit = $(unitBlock).index();
                      var numUnit = fieldValue[indexUnit].replace(
                        /([0-9])+/g,
                        function (match) {
                          return unit.pad(match, scope.option.aptNum);
                        },
                      );

                      var num_basic =
                        alphaTower +
                        scope.option.towerSeparator +
                        idTower +
                        scope.option.floorSeparator +
                        unit.pad(numFloor, scope.option.floorNum) +
                        scope.option.aptSeparator;
                      var num = num_basic + numUnit;
                      var num_clean = numUnit;

                      inputNumBasic.val(num_basic).trigger('input');
                      if (inputNumClean.length == 2) {
                        inputNumClean
                          .eq(0)
                          .val(unit.pad(numUnit, scope.option.aptNum))
                          .trigger('input');
                        inputNumClean
                          .eq(1)
                          .val(unit.pad(numUnit + 'A', scope.option.aptNum))
                          .trigger('input');
                      } else {
                        inputNumClean
                          .val(unit.pad(numUnit, scope.option.aptNum))
                          .trigger('input');
                      }
                      data.num[inputNumBasic.data('unit-id')] = num;
                      data.num_basic[inputNumBasic.data('unit-id')] = num_basic;
                      data.num_clean[inputNumClean.data('unit-id')] = num_clean;
                    }
                  });
              });
            } else if (fieldValue.length < fieldLength) {
              alert('Please, define apartment number for each column.');
            }
            scope.$apply();
            var url = api.apt.change.replace(
              '{{sectionId}}',
              $rootScope.sectionId,
            );
            request.post(url, data);
          });
        },
      };
    },
  )
  .directive('estFloorValue', function (request, debounce, $rootScope, unit) {
    return {
      scope: {
        value: '=ngModel',
        type: '@estFloorValue',
        url: '@',
      },
      link: function (scope, element, attr) {
        scope.$watch('value', function (newVal, oldVal) {
          if (newVal != oldVal && newVal != '') {
            var floor = $(element)
              .parents('.b-house__floor')
              .find('.b-textfield')
              .not('.js-floorExclude')
              .not("[disabled='disabled']");
            var data = {};
            data[scope.type] = {};
            floor.each(function (i, input) {
              $(input).val(newVal);
              $(input).trigger('input');
              data[scope.type][$(input).data('unit-id')] = newVal;
            });
            unit.columnChange = true;
            data.price_id = unit.priceId;
            debounce(function () {
              $rootScope.requestLoader = true;
              var url = scope.url.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );
              if (scope.type == 'price') {
                url += '?pl=' + unit.priceId;
              }
              request.post(url, data, function (response) {
                $rootScope.requestLoader = false;
                unit.columnChange = false;
              });
            }, 400);
          }
        });
      },
    };
  })
  .directive(
    'estFeatureUnit',
    function (
      $rootScope,
      request,
      api,
      unit,
      find,
      $compile,
      $templateCache,
      $state,
    ) {
      return {
        scope: {
          feature: '=estFeatureUnit',
          customFeature: '=',
          customFeatureValue: '=',
          url: '@',
        },
        link: function (scope, element, attr) {
          function isEmpty(el) {
            return !$.trim(el.html());
          }

          element.on('click', function (event) {
            // нужно переписать условие, что бы при последующих проходах игнорился шифт
            if (event.shiftKey && false) {
              // от первой нажатой до второй trigger click
            }
            // активно добавление фич
            else if (unit.activeHouse == 'features' && !isEmpty(element)) {
              var url = api.feature.mark.replace('{{unitId}}', attr.unitId);
              var data = {
                label_id: scope.feature,
              };
              var labelName = $('.js-selectFeature option:selected').text();
              var mark = $('.js-selectFeature option:selected').attr(
                'data-feature-mark',
              );

              if (
                !$(
                  '.b-roomlabels__el[data-feature-id=' + scope.feature + ']',
                  element,
                ).length
              ) {
                // если нет, добавить нужные классы
                $(element).addClass('-type_featured -mark_highlight');
                var label =
                  '<span class="b-roomlabels__el" data-feature-label="' +
                  mark +
                  '" data-feature-name="' +
                  labelName +
                  '" data-feature-id="' +
                  scope.feature +
                  '">' +
                  mark +
                  '</span>';
                console.log(label);
                var compileLabel = $compile(label)(scope);
                element.find('.b-roomlabels').append(compileLabel);
              } else {
                // если такая метка уже была, убрать ее и нужные классы
                $(element).removeClass('-type_featured -mark_highlight');
                var indexFeature = find.byValue(
                  unit.featureLabel,
                  'name',
                  labelName,
                );
                if (indexFeature !== null) {
                  unit.featureLabel[indexFeature].count -= 1;
                  if (unit.featureLabel[indexFeature].count == 0) {
                    unit.featureLabel.splice(indexFeature, 1);
                  }
                }
                element
                  .find('.b-roomlabels__el[data-feature-label="' + mark + '"]')
                  .remove();
              }
              // отправить изменения на сервер
              request.post(url, data);
            }
            // активно добавление кастом филдов
            else if (
              unit.activeHouse == 'customFeatures' &&
              !isEmpty(element)
            ) {
              var url = api.feature.markCustom.replace(
                '{{unitId}}',
                attr.unitId,
              );
              var data = {
                field_id: scope.customFeature.id,
                value: scope.customFeatureValue,
              };

              // t - hidden input with data
              var t = $(element).find(
                '.customField[data-field-id=' + scope.customFeature.id + ']',
              );
              var value = t.attr('data-field-value');
              // str - строка со всеми значениями
              var str = $('.js-customFeatureString', element).text();
              if (str) {
                str = str.replace(/\s/g, '');
                var strArray = str.split(',');
              } else {
                var strArray = [];
              }
              // если у нас несколько кастом-филдов применено к юниту
              if (t.length) {
                if (value == scope.customFeatureValue) {
                  //удалить метку
                  var index = strArray.indexOf(value);
                  strArray.splice(index, 1);
                  t.remove();
                  //$('.customField[data-field-id=' + scope.customFeature.id + ']', element).remove();
                  $(element).removeClass('-type_featured');
                  var indexCustom = find.multiValue(
                    unit.customLabel,
                    'id',
                    scope.customFeature.id,
                    'value',
                    scope.customFeatureValue,
                  );
                  if (indexCustom !== null) {
                    unit.customLabel[indexCustom].count -= 1;
                    if (unit.customLabel[indexCustom].count == 0) {
                      unit.customLabel.splice(indexCustom, 1);
                    }
                  }
                  request.post(url, data);
                } else {
                  if (value) {
                    //заменить метку
                    var index = strArray.indexOf(value);
                    strArray[index] = scope.customFeatureValue;
                    t.remove();
                    var field =
                      '<input type="hidden" class="customField" data-field-id="' +
                      scope.customFeature.id +
                      '" data-field-name="' +
                      scope.customFeature.name +
                      '" data-field-value="' +
                      scope.customFeatureValue +
                      '" data-custom-label/>';
                    var compileField = $compile(field)(scope);
                    element.append(compileField);
                    var indexCustom = find.multiValue(
                      unit.customLabel,
                      'id',
                      scope.customFeature.id,
                      'value',
                      value,
                    );
                    if (indexCustom !== null) {
                      unit.customLabel[indexCustom].count -= 1;
                      if (unit.customLabel[indexCustom].count == 0) {
                        unit.customLabel.splice(indexCustom, 1);
                      }
                    }
                    $(element).addClass('-type_featured');
                    request.post(url, data, function (response) {
                      if (response.data.result == 'deleted') {
                        request.post(url, data);
                      }
                    });
                  } else {
                    //поставить метку
                  }
                }
              }
              // если мы впервые применяем кастом-филд
              else {
                //добавить новую метку
                if (!$('.js-customFeatureString', element).length) {
                  strArray = [];
                  element.append(
                    '<span class="js-customFeatureString"></span>',
                  );
                }
                strArray.unshift(scope.customFeatureValue);

                var field =
                  '<input type="hidden" class="customField" data-field-id="' +
                  scope.customFeature.id +
                  '" data-field-name="' +
                  scope.customFeature.name +
                  '" data-field-value="' +
                  scope.customFeatureValue +
                  '" data-custom-label/>';

                var compileField = $compile(field)(scope);
                $(element).addClass('-type_featured');
                element.append(compileField);
                request.post(url, data);
              }

              // соединить все значения в строку
              $('.js-customFeatureString', element).text(strArray.join(', '));
            } else if (!isEmpty(element)) {
              // Деактивировал открытие попапа на странице фич
              /*$('.b-house__unit').removeClass('-state-active');
            element.addClass('-state-active');
            $state.go('unitpopup.view', {id: attr.unitId});*/
            }
          });
        },
      };
    },
  )
  .directive('estMarkFeature', function (unit) {
    return {
      scope: {
        type: '@estMarkFeature',
        featureId: '=',
        featureValue: '=',
      },
      link: function (scope, element, attr) {
        scope.activeHouse = false;
        element.on('click', function (event) {
          event.preventDefault();
          $('.js-activateHouse').not(element).removeClass('-state_done');
          $(element).toggleClass('-state_done');
          scope.activeHouse = $(element).hasClass('-state_done');
          if (scope.activeHouse) {
            unit.activeHouse = scope.type;
            console.log(scope.featureValue);
            var parent = $(
              '.customField[data-field-value=' + scope.featureValue + ']',
            ).parents('.b-house__unit');
            parent.addClass('-type_featured');
            $(
              '.js-highlightFeature[data-feature-id=' + scope.featureId + ']',
            ).each(function (i, unitBlock) {
              var p = $(unitBlock).parents('.b-house__unit');
              p.addClass('-type_featured -mark_highlight');
            });
            $('.b-house').addClass('-type_edit');
          } else {
            unit.activeHouse = '';
            $('.b-house__unit').removeClass('-type_featured -mark_highlight');
            $('.b-house').removeClass('-type_edit');
          }
        });
      },
    };
  })
  .directive('featureLabel', function (unit, find) {
    return {
      scope: {
        label: '@featureLabel',
        name: '@featureName',
      },
      link: function (scope, element, attr) {
        var index = find.byValue(unit.featureLabel, 'name', scope.name);
        if (index === null) {
          unit.featureLabel.push({
            name: scope.name,
            label: scope.label,
            count: 1,
          });
        } else {
          unit.featureLabel[index].count += 1;
        }
      },
    };
  })
  .directive('estFeatureHighlight', function () {
    return {
      link: function (scope, element, attr) {
        element
          .on('mouseenter', function (event) {
            var parent = $(
              '.b-roomlabels__el[data-feature-name="' + scope.label.name + '"]',
            ).parents('.b-house__unit');
            parent.addClass('-type_featured');
          })
          .on('mouseleave', function () {
            $('.b-house__unit').each(function (i, unitBlock) {
              if (!$(unitBlock).hasClass('-mark_highlight')) {
                $(unitBlock).removeClass('-type_featured');
              }
            });
          });
      },
    };
  })
  .directive('featureCustom', function (unit) {
    return {
      scope: {
        content: '@',
        type: '@',
        customField: '=featureCustom',
        featureChoiceList: '=featureList',
      },
      link: function (scope, element, attr) {
        element.on('click', function (event) {
          scope.customField.type = scope.type;
          if (scope.type == 4 && scope.content) {
            scope.featureChoiceList = scope.content.split(';;');
          }
          scope.$apply();
        });
      },
    };
  })
  .directive('customLabel', function (unit, find) {
    return {
      scope: {
        fieldName: '@',
        fieldValue: '@',
        fieldId: '@',
      },
      link: function (scope, element, attr) {
        var index = find.byValue(unit.customLabel, 'value', scope.fieldValue);
        if (index === null) {
          unit.customLabel.push({
            name: scope.fieldName,
            value: scope.fieldValue,
            id: scope.fieldId,
            count: 1,
          });
        } else {
          unit.customLabel[index].count += 1;
        }
      },
    };
  })
  .directive('estCustomHighlight', function (unit) {
    return {
      link: function (scope, element, attr) {
        element
          .on('mouseenter', function (event) {
            var parent = $(
              '.customField[data-field-value="' + scope.item.value + '"]',
            ).parents('.b-house__unit');
            parent.addClass('-type_featured');
          })
          .on('mouseleave', function () {
            $('.b-house__unit').removeClass('-type_featured');
          });
      },
    };
  })
  .directive(
    'estReviewUnit',
    function (
      $rootScope,
      request,
      api,
      unit,
      find,
      $compile,
      $templateCache,
      $state,
    ) {
      return {
        scope: {
          statusId: '=estReviewUnit',
          url: '@',
        },
        link: function (scope, element, attr) {
          // TODO  проверить, работает ли след. строка
          function isEmpty(el) {
            return !$.trim(el.html());
          }
          element.on('click', function () {
            if (unit.activeHouse && !isEmpty(element)) {
              var data = {};
              switch (unit.activeHouse) {
                case 'booked':
                  data.status_id = 3;
                  $(element).addClass('-type_reservation');
                  break;
                case 'sold':
                  data.status_id = 4;
                  $(element).addClass('-type_sold');
                  break;
                case 'notinstock':
                  data.status_id = 1;
                  $(element).addClass('-type_notinstock');
                  break;
                case 'free':
                  data.status_id = 2;
                  $(element)
                    .removeClass(
                      '-type_reservation -type_sold -type_notinstock',
                    )
                    .addClass('-type_available');
                  break;
              }
              var url = api.review.status.replace('{{unitId}}', attr.unitId);
              data.is_fast_deal = 1;
              request.post(url, data);
            } else if (!isEmpty(element)) {
              $('.b-house__unit').removeClass('-state-active');
              element.addClass('-state-active');
              $state.go('unitpopup.view', { id: attr.unitId });
            }
          });
        },
      };
    },
  )
  .directive(
    'estImageColumn',
    function (request, api, $rootScope, unit, $compile) {
      return {
        scope: {
          type: '@imageType',
          image_id: '@imageId',
          show: '=deleteImage',
          planType: '@deleteImage',
        },
        link: function (scope, element, attr) {
          var parent = $(element).closest('.l-houseUnit');
          var index = parent.index();
          element
            .on('mouseenter', function () {
              if (unit.activeHouse == 'markImage') {
                angular.forEach(MatrixTower[index].elements, function (el, i) {
                  if (el.length > 1) {
                    angular.forEach(el, function (subEl, i) {
                      $(subEl).addClass('-type_featured');
                    });
                  } else {
                    $(el).addClass('-type_featured');
                  }
                });
              }
            })
            .on('mouseleave', function () {
              angular.forEach(MatrixTower[index].elements, function (el, i) {
                if (el.length > 1) {
                  angular.forEach(el, function (subEl, i) {
                    if (!$(subEl).hasClass('-mark_highlight')) {
                      $(subEl).removeClass('-type_featured');
                    }
                  });
                } else {
                  if (!$(el).hasClass('-mark_highlight')) {
                    $(el).removeClass('-type_featured');
                  }
                }
              });
            })
            .on('click', function () {
              if (unit.activeHouse == 'markImage') {
                var data = {};
                angular.forEach(
                  MatrixTower[index].elements,
                  function (unitBlock, i) {
                    if (unitBlock.length > 1) {
                      angular.forEach(unitBlock, function (subEl, i) {
                        $(subEl).addClass('-type_featured -mark_highlight');
                        var id = $(subEl).data('unit-id');
                        var url = api.image.bind.replace('{{unitId}}', id);
                        data.image_type = unit.planType;
                        data.image_id = unit.image_id;
                        var attach = $(subEl).find(
                          '.js-imageHighlight[data-image-id=' +
                            unit.image_id +
                            ']',
                        );
                        if (!attach.length) {
                          $(subEl).addClass('-type_featured -mark_highlight');
                          var inputData =
                            '<input type="hidden" class="js-imageHighlight" data-image-id="' +
                            unit.image_id +
                            '" data-image-type="' +
                            unit.planType +
                            '" data-attach-image/>';
                          var inputDataCompile = $compile(inputData)(scope);
                          $(subEl).append(inputDataCompile);
                          request.post(url, data, function (response) {});
                        }
                      });
                    } else {
                      $(unitBlock).addClass('-type_featured -mark_highlight');
                      var id = $(unitBlock).data('unit-id');
                      var url = api.image.bind.replace('{{unitId}}', id);
                      data.image_type = unit.planType;
                      data.image_id = unit.image_id;
                      var attach = $(unitBlock).find(
                        '.js-imageHighlight[data-image-id=' +
                          unit.image_id +
                          ']',
                      );
                      if (!attach.length) {
                        $(unitBlock).addClass('-type_featured -mark_highlight');
                        var inputData =
                          '<input type="hidden" class="js-imageHighlight" data-image-id="' +
                          unit.image_id +
                          '" data-image-type="' +
                          unit.planType +
                          '" data-attach-image/>';
                        var inputDataCompile = $compile(inputData)(scope);
                        $(unitBlock).append(inputDataCompile);
                        request.post(url, data);
                      }
                    }
                  },
                );
              }
            });
        },
      };
    },
  )
  .directive(
    'deleteImage',
    function (request, api, $rootScope, unit, find, $timeout) {
      return {
        scope: {
          type: '@imageType',
          image_id: '@imageId',
          show: '=',
          planType: '@deleteImage',
          image: '=',
          imageArray: '=',
        },
        link: function (scope, element, attr) {
          element.on('click', function (event) {
            event.preventDefault();
            var url = api.image.remove;
            var data = {
              type: 'section',
              image_id: scope.image_id,
              id: $rootScope.sectionId,
            };

            $('.b-house__unit').removeClass('-type_featured -mark_highlight');
            if (unit.activeHouse) {
              unit.activeHouse = '';
              unit.planType = '';
              unit.image_id = '';
              $('.b-house').removeClass('-type_edit');
            }
            var index = find.byValue(scope.imageArray, 'id', scope.image_id);
            scope.imageArray.splice(index, 1);
            scope.$apply(function () {
              scope.show = false;
              if ($('.js-imageField').is(':empty')) {
                scope.image = 'None';
              } else {
                scope.image = '';
              }
            });
            element.parents('.b-imgControl').remove();
            request.post(url, data, function (response) {});
          });
        },
      };
    },
  )
  .directive(
    'deleteAvatar',
    function (request, api, $rootScope, unit, find, $timeout) {
      return {
        scope: {
          type: '@imageType',
          image_id: '@imageId',
          show: '=',
          planType: '@deleteImage',
          image: '=',
          imageArray: '=',
        },
        link: function (scope, element, attr) {
          element.on('click', function (event) {
            event.preventDefault();
            var url = api.image.remove;
            var data = {
              type: 'section',
              image_id: scope.image_id,
              id: $rootScope.sectionId,
            };
            element.parents('.b-imgControl').remove();
            $('.js-userAvatar').scope().imageAvatar = '';
            request.post(url, data, function (response) {});
          });
        },
      };
    },
  )
  .directive(
    'estPlanUnit',
    function (
      $rootScope,
      request,
      api,
      unit,
      find,
      $compile,
      $timeout,
      $templateCache,
      $state,
    ) {
      return {
        scope: {
          planType: '=estPlanUnit',
          url: '@',
        },
        link: function (scope, element, attr) {
          function isEmpty(el) {
            return !$.trim(el.html());
          }
          var parent = element.parents('.b-house__floorHouserooms');
          element
            .on('mouseenter', function () {
              if (unit.planType == '2') {
                parent.find('.b-houseroom').addClass('-type_featured');
              }
            })
            .on('mouseleave', function () {
              if (unit.planType == '2') {
                parent.find('.b-houseroom').each(function (i, el) {
                  if (!$(el).hasClass('-mark_highlight')) {
                    $(el).removeClass('-type_featured');
                  }
                });
              } else {
                if (!$(element).hasClass('-mark_highlight')) {
                  $(element).removeClass('-type_featured');
                }
              }
            })
            .on('click', function () {
              if (unit.activeHouse == 'markImage') {
                var data = {};
                //floor
                if (unit.planType == '2') {
                  parent.find('.b-houseroom').each(function (i, unitBlock) {
                    if (!$(unit).hasClass('g-hidden')) {
                      var id = $(unitBlock).data('unit-id');
                      var url = api.image.bind.replace('{{unitId}}', id);
                      data.image_type = unit.planType;
                      data.image_id = unit.image_id;
                      var numFloor = $(element)
                        .parents('.js-num-floor')
                        .data('num-floor');

                      if ($(unitBlock).hasClass('-mark_highlight')) {
                        var index =
                          unit.imagesFloor[unit.image_id].indexOf(numFloor);
                        if (index >= 0) {
                          unit.imagesFloor[unit.image_id].splice(index, 1);
                        }
                        $(unitBlock)
                          .removeClass('-mark_highlight')
                          .find(
                            '.js-imageHighlight[data-image-id=' +
                              unit.image_id +
                              ']',
                          )
                          .remove();
                      } else {
                        if (!unit.imagesFloor[unit.image_id]) {
                          unit.imagesFloor[unit.image_id] = [numFloor];
                        } else {
                          if (
                            unit.imagesFloor[unit.image_id].indexOf(numFloor) <
                            0
                          ) {
                            unit.imagesFloor[unit.image_id].push(numFloor);
                          }
                        }
                        var inputData =
                          '<input type="hidden" class="js-imageHighlight" data-image-id="' +
                          unit.image_id +
                          '" data-image-type="' +
                          unit.planType +
                          '" data-attach-image/>';
                        var inputDataCompile = $compile(inputData)(scope);
                        $(unitBlock).append(inputDataCompile);
                        $(unitBlock).addClass('-type_featured -mark_highlight');
                      }

                      request.post(url, data);
                    }
                  });
                }
                //unit, visualization
                else if (unit.planType == '3' || unit.planType == '4') {
                  var id = $(element).data('unit-id');
                  var url = api.image.bind.replace('{{unitId}}', id);
                  data.image_type = unit.planType;
                  data.image_id = unit.image_id;

                  if ($(element).hasClass('-mark_highlight')) {
                    unit.images[unit.image_id].count -= 1;
                    $(element)
                      .removeClass('-mark_highlight')
                      .find(
                        '.js-imageHighlight[data-image-id=' +
                          unit.image_id +
                          ']',
                      )
                      .remove();
                  } else {
                    var inputData =
                      '<input type="hidden" class="js-imageHighlight" data-image-id="' +
                      unit.image_id +
                      '" data-image-type="' +
                      unit.planType +
                      '" data-attach-image/>';
                    var inputDataCompile = $compile(inputData)(scope);
                    element.append(inputDataCompile);
                    $(element).addClass('-type_featured -mark_highlight');
                  }
                  request.post(url, data);
                }
              } else if (!isEmpty(element)) {
                // Деактивировал открытие попапа на странице фич
                /*$('.b-house__unit').removeClass('-state-active');
              element.addClass('-state-active');

              $state.go('unitpopup.view', {id: attr.unitId});*/
                /*var sidebarPopup = $templateCache.get('largePopup.html');
              var compileSidebar = $compile(sidebarPopup)(scope);
              $('.js-largePopup').remove();
              $('.l-sidebar').prepend(compileSidebar);
              $('.mdl-js-layout').addClass('-sidebar_expanded');
              $('.js-scrollbars').perfectScrollbar().perfectScrollbar('update');;
              if(!$('.l-sidebar').hasClass('-page_leads')) {
                var offsetLeft = $(window).width() - $('.l-sidebar').offset().left;
                $('.b-sidebar__close, .b-sidebarPopup').css('left', 'calc(100vw - ' + offsetLeft + 'px)');
              }var url = scope.url.replace('unitId', attr.unitId);
              request.post(url, {}, function(response){
                unit.productionId = attr.unitId;
                var compile = $compile(response.data)(scope);
                $('.b-sidebarPopup').html(compile);
                $('.js-scrollbars').perfectScrollbar('update');
                $('.b-sidebarPopup').find('input, select').styler();
                unit.initJqueryFunc();
              });
              */
              }
            });
        },
      };
    },
  )
  .directive(
    'estMarkImage',
    function ($rootScope, request, api, unit, find, $compile) {
      return {
        scope: {
          planType: '@estMarkImage',
          imageId: '@',
          show: '=',
        },
        link: function (scope, element, attr) {
          element.on('click', function (event) {
            event.preventDefault();
            $('.js-activateHouse').not(element).removeClass('-state_done');
            if (unit.image_id != scope.imageId) {
              $('.b-house__unit').removeClass('-type_featured -mark_highlight');
            }
            $(element).toggleClass('-state_done');
            if ($(element).hasClass('-state_done')) {
              scope.$apply(function () {
                if (scope.planType == '3' || scope.planType == '4') {
                  scope.show = true;
                } else {
                  scope.show = false;
                }
              });

              unit.activeHouse = 'markImage';
              $('.b-house').addClass('-type_edit');
              unit.planType = scope.planType;
              unit.image_id = scope.imageId;
              $('.js-imageHighlight').each(function (i, el) {
                if ($(el).data('image-id') == scope.imageId) {
                  $(el)
                    .parents('.b-house__unit')
                    .addClass('-type_featured -mark_highlight');
                }
              });
            } else {
              scope.$apply(function () {
                scope.show = false;
              });
              unit.activeHouse = '';
              unit.planType = '';
              unit.image_id = '';
              $('.b-house').removeClass('-type_edit');
              $('.b-house__unit').removeClass('-type_featured -mark_highlight');
            }
          });
        },
      };
    },
  )
  .directive('attachImage', function (unit, $compile, $timeout) {
    return {
      scope: {
        imageId: '@',
        imageType: '@',
      },
      link: function (scope, element, attr) {
        var parent = $(element).parents('.js-num-floor');
        var numFloor = parent.data('num-floor');
        if (scope.imageType != '2') {
          if (!unit.images[scope.imageId]) {
            unit.images[scope.imageId] = { count: 1 };
          } else {
            unit.images[scope.imageId].count += 1;
          }
        } else {
          if (parent.length) {
            if (!unit.imagesFloor[scope.imageId]) {
              unit.imagesFloor[scope.imageId] = [numFloor];
            } else {
              if (
                numFloor &&
                unit.imagesFloor[scope.imageId].indexOf(numFloor) < 0
              ) {
                unit.imagesFloor[scope.imageId].push(numFloor);
              }
            }
          }
        }
      },
    };
  })
  .directive('imageFloor', function (unit) {
    return {
      scope: {
        imageId: '@imageFloor',
        imageType: '@',
      },
      controller: function ($scope) {
        $scope.$watch(
          function () {
            return unit.imagesFloor[$scope.imageId];
          },
          function (newVal) {
            $scope.floors = unit.imagesFloor[$scope.imageId];
          },
        );
      },
      template:
        '<span ng-repeat="floor in floors" class="js-sterh"><span ng-bind="floor"></span><span ng-hide="$last">, </span></span>',
      link: function (scope, element, attr) {
        /*        element.on('mouseenter', function(){
          if(!unit.activeHouse){
            scope.floors.forEach(function(el){
              $('.js-num-floor[data-num-floor=' + el + ']').find('.b-house__unit').addClass('-type_featured');
            });
          }
        })
          .on('mouseleave', function(){
            if(!unit.activeHouse){
              $('.b-house__unit').removeClass('-type_featured');
            }
          });*/
      },
    };
  })
  .directive('imageHighlight', function (unit) {
    return {
      scope: {
        imageId: '@imageHighlight',
        imageType: '@',
      },
      link: function (scope, element, attr) {
        /*        element.on('mouseenter', function(event){
          var parent = $('.js-imageHighlight[data-image-id=' + scope.imageId + ']').parents('.b-house__unit');
          parent.addClass('-type_featured');
        })
          .on('mouseleave', function(){
            $('.b-house__unit').removeClass('-type_featured');
          });*/
      },
    };
  });

// используется в estHouseColumn, estImageColumn
var MatrixTower;

$(function () {
  updateGrid();
  // searchHelpers(); //уже не используется
});

function updateGrid() {
  var m = [];
  var n = 0;
  var phase = false;
  $('.b-house__unit:not(.g-hidden)').each(function (i, unit) {
    if (!phase) {
      if ($(unit).parent().index() == 0) n = 0;
      m[n] = m[n] || {};
      if (!m[n].elements) m[n].elements = {};
      m[n].elements[i] = [];
      m[n].elements[i].push(unit);
      if ($(unit).hasClass('-type_united')) {
        n++;
      }
      if ($(unit).hasClass('-type_divided')) {
        m[n].type = 'divided';
        m[n].elements[i].push($(unit).next());
        phase = true;
      }
      n++;
    } else {
      phase = false;
    }
  });

  m.forEach(function (tower, j) {
    if (tower.type == 'divided') {
      if (m[j - 1]) {
        $.each(m[j - 1].elements, function (i, unit) {
          if ($(unit).hasClass('-type_united')) {
            $(unit[0]).parent().addClass('-inDividedApartmentBlock');
          }
        });
      }
      $.each(tower.elements, function (i, unit) {
        $(unit[0]).parent().addClass('-inDividedApartmentBlock');
        if (unit[1]) $(unit[1]).parent().addClass('-inDividedApartmentBlock');
      });
    }
  });
  //  makeParkingWidth();
  MatrixTower = m;
}
var $searchField;
